var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "article",
  "use": "article-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"article\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\"><path d=\"M10 6h9l5 5v13a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2ZM10 13.5h12M10 16.5h12M10 20h12M10 23h12\" /><path d=\"M19 6v5h5\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol